import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Page, Crud } from '../../components'
import moment from 'moment'
import * as userActions from '../user/redux/actions';
import { Input, Select } from 'antd';
const Option = Select.Option;
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud;
export class ProductDetail extends Component {
  static propTypes = {
    gkproduct: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { pro_lnglistPage } = this.props.gkproduct;
    const { getFrui_qppzList } = this.props.userActions;
    this.fetchList(pro_lnglistPage);
    // 气瓶品种筛选
    getFrui_qppzList({ page: 1, size: 999 });
  }

  fetchList = (page, values) => {
    const { getProductListActions } = this.props.actions;


    let params = Object.assign({}, { page: page, orderBy: 'pid' }, { pid: this.pid, pidTrace: this.pidTrace, qpCode: this.qpCode })
    getProductListActions(params);
  }

  getDataSource() {
    const { gkproduct } = this.props;
    const { pro_lnglistById, pro_lnglistList } = gkproduct;
    if (!pro_lnglistList) return [];
    return pro_lnglistList.map(id => pro_lnglistById[id]);
  }
  get listProps() {
    const { gkproduct, actions } = this.props
    const { getProductListActionsPending, pro_lnglistTotal, pro_lnglistPage } = gkproduct
    const { productListParticularsIdActions, chooseCurrentProduct } = actions;
    return {
      dataSource: this.getDataSource(),
      loading: getProductListActionsPending,
      scroll: { x: 1300 },
      columns: [
        {
          title: "气瓶编号",
          dataIndex: 'pid',
          key: 'pid',
          width: 180,
        },
        {
          title: "气瓶唯一追溯编号",
          dataIndex: 'pidTrace',
          key: 'pidTrace',
          width: 180,
        },
        {
          title: "气瓶型号",
          dataIndex: 'typeName',
          key: 'typeName',
          width: 180,
        },
        {
          title: "制造日期",
          dataIndex: 'pdate',
          key: 'pdate',
          width: 180,
          render: (text) => {
            if (text != undefined) {
              return <div>{moment(text).format("YYYY-MM-DD")}</div>
            } else {
              return <div></div>
            }
          }
        },
      ],
      pagination: {
        total: pro_lnglistTotal,
        current: pro_lnglistPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 1,
          name: '追溯',
        },
      ],
      handleMenuClick: (record, item) => {
        if (item.key === 1) {
          productListParticularsIdActions(record.id).then((res) => {
            console.log(res)
            chooseCurrentProduct(res)
            window.open(`/gkproduct/SearchProduct/` + record.id)

          })
        }
      }
    }
  }


  get filterProps() {
    const { actions, gkproduct } = this.props;
    const { pro_lnglistPage } = gkproduct;
    let self = this
    return {
      title: '',
      searchElements: [
        {
          key: 'pidTrace',
          widget: Input,
          widgetProps: {
            placeholder: '请输入唯一追溯编号',
          },
        },
        {
          key: 'pid',
          widget: Input,
          widgetProps: {
            placeholder: '气瓶编号',
          },
        },
        {
          key: "qpCode",
          widget: Select,
          widgetProps: {
            style: { width: 200 },
            placeholder: "气瓶品种",
          },
          children: this.choosePqpz()
        }
      ],
      onFilterChange: value => {
        this.pidTrace = value.pidTrace;
        this.pid = value.pid;
        this.qpCode = value.qpCode;
        this.fetchList(1);
      },
      onAdd() {
      },
    };
  }

  choosePqpz = () => {
    let { user } = this.props;
    const { frui_qppzById, frui_qppzList } = user;
    return frui_qppzList.map(id => frui_qppzById[id]).map(item => <Option key={item.qpCode}>{item.qpName}</Option>)
  }


  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudTable {...this.listProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    gkproduct: state.gkproduct,
    user: state.user
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    userActions: bindActionCreators({ ...userActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetail);



// WEBPACK FOOTER //
// ./src/features/gkproduct/ProductDetail.js